import { Controller } from "@hotwired/stimulus"

// Generic: submits the controller's own element (a <form>) whenever a
// child control fires the bound event, e.g. a checkbox styled as a
// switch that should POST immediately on change instead of needing an
// explicit submit button.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
